module.exports = __webpack_public_path__ + "assets/9594de7cfd0ce077ad95f02c93e7384f.mp4";